/** Content library with this asset open in the lightbox. */
export function contentAssetPath(assetId: string): string {
  return `/content?${new URLSearchParams({ assetId }).toString()}`;
}

/** Search param naming the display that Library uploads should go straight onto. */
export const UPLOAD_FOR_SCREEN_PARAM = 'forScreen';

/** Library with the file chooser open; finished uploads play on `screenId`. */
export function contentUploadForScreenPath(screenId: string): string {
  return `/content?${new URLSearchParams({ [UPLOAD_FOR_SCREEN_PARAM]: screenId }).toString()}#upload`;
}
